import React, { useState, useImperativeHandle, forwardRef } from "react";
import {
    _orderEquipmentDetail,
    _equipmentDetailList,
    _orderBindingEquipment,
    _imageUpload
} from "@/statics/js/api.js";
import './index.less'
import { zipImg } from '@/statics/js/util'
import { Modal, message, Form,Select,Upload,Icon } from "antd";
const Option = Select.Option

var Index = Form.create({})(forwardRef((props, ref) => {
  const { form, done } = props
    const {
      getFieldDecorator,
      resetFields,
      setFieldsValue,
      getFieldValue,
      getFieldsValue
    } = form
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [orderId, setOrderId] = useState();
    const [bikeOptions,setBikeOptions] = useState([])
    const [batteryOptions,setBatteryOptions] = useState([])
    const [detail,setDetail] = useState({})
    const [fileList,setFileList] = useState([])
    const [transferFileList,setTransferFileList] = useState([])
    const [max,setMax] = useState(12)
    const [transferMax,setTransferMax] = useState(12)
  useImperativeHandle(
    ref,
    () => ({
      open,
    }),
    []
  );

  const open = async ({ id }) => {
    setVisible(true);
    setOrderId(id);
    setFileList([])
    setTransferFileList([])
    getDetail(id)
    getDeviceOptions(id)
  };
  const close = async () => {
    setVisible(false);
  };
  const getDetail = async (id)=>{
    const res = await _orderEquipmentDetail({orderId: id})
    const data = res.data.data || {}
    setDetail(data)
    const currentNum = data.img?.length || 0
    const currentTransferNum = data.transferImgList?.length || 0
    setMax(12-currentNum)
    setTransferMax(12-currentTransferNum)
    setTimeout(() => {
      resetFields()
    }, 10);
  }
  const getDeviceOptions = async (id)=>{
    const res = await _equipmentDetailList({orderId: id})
    const {batteryList=[],bikeList=[]} = res.data.data || {}
    setBikeOptions(bikeList)
    setBatteryOptions(batteryList)
  }
//   // 提交
  const handleOk = async () => {
    const values = getFieldsValue()
    let batteryIds = []
    detail.battery && detail.battery.map((item,index)=>{
      const batteryIdKey = `batteryId-${index}`
      if(values[batteryIdKey]){
        batteryIds.push(values[batteryIdKey])
      }
    })
    let transferImgList = values.transferImgList || []
    let imgList = values.imgList || []
    if(!values.bikeId && !batteryIds.length && !imgList.length && !transferImgList.length){
      close();
      return
    }
    imgList = imgList.map((item)=>item.response?.data?.path)
    transferImgList = transferImgList.map((item)=>item.response?.data?.path)
    const params = {
      orderId,
      bikeId: values.bikeId || undefined,
      batteryIds: batteryIds.length ? batteryIds : undefined,
      imgList: imgList.length ? imgList : undefined,
      transferImgList: transferImgList.length ? transferImgList : undefined,
    }
    setConfirmLoading(true);
    const res = await _orderBindingEquipment(params);
    setConfirmLoading(false);
    const { code, message: msg } = res.data || {};
    if (code != 200) {
      message.warning(msg);
      return;
    } else {
      message.success('操作成功');
    }
    done();
    close();
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }
  const handleBeforeUpload = async (file) => {
    const res = await zipImg({
      file,
    })
    return res
  }
  const handleUploadChange = (type, { file, fileList }) => {
    fileList.map((item, index) => {
      if (item.status === "error") {
        fileList.splice(index, 1);
      }
      if (item.response) {
        if (item.response.code !== 200) {
          message.warning(item.response.message);
          fileList.splice(index, 1);
        }
      }
      return item;
    });
    if (type === 'send') {
      setFileList([...fileList])
    } else if (type === 'transfer') {
      setTransferFileList([...fileList])
    }
  };
  return (
    <div>
      <Modal
        title="上传资产信息"
        visible={visible}
        width={1000}
        onOk={handleOk}
        onCancel={close}
        confirmLoading={confirmLoading}
      >
        <Form>
            {
              !detail.bike ? null : 
              <Form.Item label="绑定车辆">
                  {getFieldDecorator('bikeId',{
                    initialValue: detail.bike?.bikeId || ''
                  })(
                    <Select
                        style={{ width: '100%' }}
                        placeholder="请选择车辆"
                        allowClear={!detail.bike?.bikeId}
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {bikeOptions.map((item, index) => (
                        <Option value={item.bikeId} key={index} disabled={item.binding === 1 && detail.bike?.bikeId !== item.bikeId }>
                            {item.imei}
                        </Option>
                        ))}
                    </Select>
                  )}
              </Form.Item>
            }
            {
              detail.battery?.map((row,index)=>(
                <Form.Item label="绑定电池" key={index}>
                  {getFieldDecorator(`batteryId-${index}`,{
                    initialValue: row.batteryId || ''
                  })(
                    <Select
                        style={{ width: '100%' }}
                        placeholder="请选择电池"
                        allowClear={!row.batteryId}
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {batteryOptions.map((item, index) => (
                        <Option value={item.batteryId} key={index} disabled={item.binding === 1 && !detail.battery.some(cell=>cell.batteryId === item.batteryId)}>
                            {item.imei}
                        </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              ))
            }
            <Form.Item label="上传发车图片" extra={max <= 0 ? '' : '最多上传12张照片'}>
                {
                  detail.img?.map((item,index)=>(
                    <img className="deviceImg" src={item.hcImg} key={index} />
                  ))
                }
                {getFieldDecorator('imgList', {
                  getValueFromEvent: normFile,
                })(
                <Upload
                  name="uploadFile"
                  multiple={true}
                  action={_imageUpload}
                  listType="picture-card"
                  fileList={fileList}
                  accept="image/jpg,image/jpeg,image/png,image/gif"
                  onChange={(info) => handleUploadChange('send', info)}
                  beforeUpload={handleBeforeUpload}
                  data={{
                      scene: 'active',
                  }}
                >
                    {fileList.length >= max ? null : (
                        <div>
                            <Icon type="plus" style={{ fontSize: '28px' }} />
                            <p>图片上传</p>
                        </div>
                    )}
                </Upload>)}
            </Form.Item>
            <Form.Item label="上传换车图片" extra={max <= 0 ? '' : '最多上传12张照片'}>
                {
                  detail.transferImgList?.map((item,index)=>(
                    <img className="deviceImg" src={item.hcImg} key={index} />
                  ))
                }
                {getFieldDecorator('transferImgList', {
                  getValueFromEvent: normFile,
                })(
                <Upload
                  name="uploadFile"
                  multiple={true}
                  action={_imageUpload}
                  listType="picture-card"
                  fileList={transferFileList}
                  accept="image/jpg,image/jpeg,image/png,image/gif"
                  onChange={(info) => handleUploadChange('transfer', info)}
                  beforeUpload={handleBeforeUpload}
                  data={{
                      scene: 'active',
                  }}
                >
                    {transferFileList.length >= transferMax ? null : (
                        <div>
                            <Icon type="plus" style={{ fontSize: '28px' }} />
                            <p>图片上传</p>
                        </div>
                    )}
                </Upload>)}
            </Form.Item>
          </Form>
      </Modal>
    </div>
  );
}))

export default Index;
